import { Mail, Phone } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { ccLogo } from "../../assets/data/Assests";
import { initiateAppleLogin } from "../../services/appleAuth";

const AppleIcon = () => (
    <svg className="inline h-4 w-4 mr-3 mb-0.5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
    </svg>
);

export default function CreateAccountWith() {
    const navigate = useNavigate();

    const buttons = [
        {
            id: "email",
            icon: <Mail className="inline h-4 w-4 mr-3 mb-1" />,
            text: "Continue with Email",
            onClick: () => navigate("/create-account/email"),
        },
        {
            id: "phone",
            icon: <Phone className="inline h-4 w-4 mr-3 mb-1" />,
            text: "Continue with Phone Number",
            onClick: () => navigate("/create-account/phone"),
        },
    ];

    return (
        <div className="h-full w-full bg-white dark:bg-[#1E1D21] flex flex-col justify-between relative md:overflow-hidden">
            <div className="mt-0">
                <div className="flex flex-col p-4">
                    <img
                        alt="logo"
                        src={ccLogo}
                        className="h-16 w-16"
                    />
                    <p className="text-[22px] font-bold text-black dark:text-white mt-3">Create an account</p>
                    <p className="text-[14px] font-semibold text-gray-800 dark:text-gray-300">Join Chaa Chingg in under a minute.</p>
                </div>
                <div className="flex flex-col px-4">
                    {buttons.map((button) => (
                        <button
                            key={button.id}
                            type="button"
                            className="w-full h-12 px-5 text-[12px] mb-3 font-semibold text-start rounded-lg bg-[#BDE6FF] text-gray-900"
                            onClick={button.onClick}
                        >
                            {button.icon}
                            {button.text}
                        </button>
                    ))}

                    <div className="flex items-center gap-3 my-1">
                        <hr className="flex-1 border-gray-300 dark:border-gray-600" />
                        <span className="text-[11px] text-gray-400 font-medium">OR</span>
                        <hr className="flex-1 border-gray-300 dark:border-gray-600" />
                    </div>

                    <button
                        type="button"
                        onClick={initiateAppleLogin}
                        className="w-full h-12 px-5 text-[12px] mt-3 font-semibold text-start rounded-lg bg-black text-white hover:bg-gray-900 transition-colors"
                    >
                        <AppleIcon />
                        Continue with Apple
                    </button>

                    <p className="text-[12px] font-medium text-center mt-4 text-black dark:text-white">
                        Already have an account?
                        <span
                            role="button"
                            tabIndex={0}
                            onClick={() => navigate("/login")}
                            onKeyDown={(e) => e.key === "Enter" && navigate("/login")}
                            className="underline cursor-pointer ml-1 text-blue-400 hover:text-blue-500 font-semibold"
                        >
                            Log in
                        </span>
                    </p>
                </div>
            </div>
            <p className="text-[10px] text-center font-medium mb-10 text-black dark:text-white">
                By continuing, you agree to our
                <span
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate("/terms-of-use")}
                    onKeyDown={(e) => e.key === "Enter" && navigate("/terms-of-use")}
                    className="underline cursor-pointer mx-1 text-blue-400 hover:text-blue-500 font-semibold"
                >
                    Terms of Use
                </span>
                and
                <span
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate("/privacy-policy")}
                    onKeyDown={(e) => e.key === "Enter" && navigate("/privacy-policy")}
                    className="underline cursor-pointer mx-1 text-blue-400 hover:text-blue-500 font-semibold"
                >
                    Privacy Policy
                </span>
            </p>
        </div>
    );
}